var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: {
        "close-on-content-click": false,
        transition: "scale-transition",
        "offset-y": "",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      class: _vm.inputClass,
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        "append-icon": "mdi-calendar",
                        readonly: "",
                        outlined: _vm.outlined,
                        dense: _vm.dense,
                        "hide-details": _vm.hideDetails,
                      },
                      on: { "click:append": on.click },
                    },
                    "v-text-field",
                    attrs,
                    false
                  ),
                  on
                )
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.menu,
        callback: function ($$v) {
          _vm.menu = $$v
        },
        expression: "menu",
      },
    },
    [
      _vm._v(" "),
      _c("v-date-picker", {
        attrs: {
          value: _vm.value,
          locale: "ko",
          "day-format": (day) => parseInt(day.slice(-2)),
          min: _vm.min,
          max: _vm.max,
        },
        on: { input: _vm.onInput },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }